import { useQuery } from "react-query";
import { fetchAggregateData } from "./api";

export function useAggregateReport(filters, options = {}) {
  return useQuery(
    ["AggregatedReport", filters],
    () => fetchAggregateData(filters),
    {
      staleTime: 60000 * 60,
      ...options,
    }
  );
}
